export const LoginUser = {
   id: undefined,
   email: undefined,
   isAdmin: undefined,
   name: undefined,
   isManager: undefined,
   isLastUser: undefined,
   isExternalLogin:undefined
}